import { AEntity } from "../a-entity";
import { AccessRight } from "./access-right";

export class AccessGroup extends AEntity {
    code: string;
    name: string;
    
    private _accessRights: AccessRight[];
    get accessRights(): AccessRight[] {
        return this._accessRights;
    }
    set accessRights(accessRights: AccessRight[]) {
        this._accessRights = this.convertArray(AccessRight, accessRights);
    }
}
